import tvgConf from "@tvg/conf";

let host = "";
const devMode = process.env.NODE_ENV === "DEVELOPMENT";

export default {
  setHost: (req) => {
    if (req) {
      host = req.hostname;
    } else if (window) {
      host = window.location.hostname;
    }
  },
  getServiceUrl: (path) =>
    devMode ? tvgConf("").config(path) : tvgConf(host).config(path),
  getBrand: () => tvgConf(host).brand
};
